import {
  Approver,
  Id,
  RequestApprovalSituation,
  RequestApprovalStatus,
  RequestTicketStatusSync,
  RequestUserData
} from 'src/types'

import {
  ResponseDataRequests,
  ResponseDataRequestsItem
} from '../requests/types'

export enum ApprovalsActionTypes {
  GET_APPROVALS = '@approvals/GET_APPROVALS',
  GET_APPROVALS_FAILURE = '@approvals/GET_APPROVALS_FAILURE',
  GET_APPROVALS_SUCCESS = '@approvals/GET_APPROVALS_SUCCESS',
  SET_APPROVAL_STATUS = '@approvals/SET_APPROVAL_STATUS',
  SET_APPROVAL_STATUS_FAILURE = '@approvals/SET_APPROVAL_STATUS_FAILURE',
  SET_APPROVAL_STATUS_SUCCESS = '@approvals/SET_APPROVAL_STATUS_SUCCESS'
}

interface RequestApproval {
  request_approval_id: Id
  request_user_data: RequestUserData
  situation: RequestApprovalSituation
  status: RequestApprovalStatus
}

interface ResponseDataApprovalsItem
  extends Omit<ResponseDataRequestsItem, 'status'> {
  approvers: Approver[]
  request_approvals: RequestApproval[]
  status: RequestApprovalStatus
  sync_status: RequestTicketStatusSync
}

export interface ResponseDataApprovals
  extends Omit<ResponseDataRequests, 'requests'> {
  requests: ResponseDataApprovalsItem[]
}

export interface ApprovalsState {
  readonly error: string
  readonly filterStatus: string[]
  readonly list: ResponseDataApprovalsItem[]
  readonly loading: boolean
  readonly reloading: boolean
  readonly setStatusError: string
  readonly setStatusLoading: boolean
  readonly setStatusSuccess: string
  readonly total_results: number
}
